(ns practitest.frontend.active-sessions.main
  (:require [practitest.frontend.active-sessions.views :as views]
            [practitest.frontend.active-sessions.events :as events]
            [practitest.frontend.active-sessions.subs :as subs]
            [re-frame.core :as re-frame]
            [reagent.dom :as rdom]))

(defn active-sessions-view []
  (if-let [_init-done? @(re-frame/subscribe [::subs/init-complete?])]
    [views/main-panel]
    [:div.loader
     [:i {:class "fa fa-spinner fa-spin fa-5x"}]]))

(defn ^:export legacy_init [config]
  (re-frame/dispatch [::events/initialize (js->clj config :keywordize-keys true)])
  (re-frame/dispatch [::events/init-complete])
  (when-let [root (js/document.getElementById "active-sessions-root")]
    (rdom/render [active-sessions-view] root)))
